module.exports = __webpack_public_path__ + "static/media/campaign-main.35be36a9.png";